 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"CycleOdds~CycleProfit~Dispersion~DynamicRetreat~Equities~Exposure~FeeRefund~FundChange~LongProfit~Lo~7ae58261":"CycleOdds~CycleProfit~Dispersion~DynamicRetreat~Equities~Exposure~FeeRefund~FundChange~LongProfit~Lo~7ae58261","CycleOdds":"CycleOdds","CycleProfit":"CycleProfit","Dispersion":"Dispersion","DynamicRetreat":"DynamicRetreat","Exposure":"Exposure","FeeRefund":"FeeRefund","FundChange":"FundChange","LongProfit":"LongProfit","LongShort":"LongShort","MonthProfit":"MonthProfit","Overnight":"Overnight","ProfitCurve":"ProfitCurve","ReturnRatio":"ReturnRatio","Sharp":"Sharp","ShortProfit":"ShortProfit","SingleVariety~VarietyWeekProfit~varietyMonthProfit":"SingleVariety~VarietyWeekProfit~varietyMonthProfit","SingleVariety":"SingleVariety","VarietyWeekProfit":"VarietyWeekProfit","varietyMonthProfit":"varietyMonthProfit","TakeCycle":"TakeCycle","TopTen":"TopTen","TradeStruct":"TradeStruct","VarietyOdds":"VarietyOdds","VarietyProfit":"VarietyProfit","WeekProfit":"WeekProfit","YieldDist":"YieldDist","Equities~NetValue":"Equities~NetValue","Equities":"Equities","NetValue":"NetValue","general":"general","home":"home","DailySett":"DailySett","HoldTotal":"HoldTotal","OptHoldTotal":"OptHoldTotal","OptTradeDetail":"OptTradeDetail","Report":"Report","TakeDetail":"TakeDetail","TakeTotal":"TakeTotal","TradeDetail":"TradeDetail","account":"account","analysis":"analysis","login":"login","replay":"replay"}[chunkId]||chunkId) + "." + {"CycleOdds~CycleProfit~Dispersion~DynamicRetreat~Equities~Exposure~FeeRefund~FundChange~LongProfit~Lo~7ae58261":"d8526f56","CycleOdds":"bb272ee8","CycleProfit":"5220af91","Dispersion":"cc668544","DynamicRetreat":"9760c7b6","Exposure":"95ebf4e2","FeeRefund":"911299fa","FundChange":"f8c728d1","LongProfit":"503b5622","LongShort":"2140960d","MonthProfit":"67d610f0","Overnight":"9ede9711","ProfitCurve":"4ae6b07c","ReturnRatio":"d2209be6","Sharp":"2a886ac4","ShortProfit":"ca5ade3a","SingleVariety~VarietyWeekProfit~varietyMonthProfit":"6709bc6f","SingleVariety":"15ae83a9","VarietyWeekProfit":"80586805","varietyMonthProfit":"537a4ca1","TakeCycle":"6f3ea4de","TopTen":"33621032","TradeStruct":"af8cfb88","VarietyOdds":"b00989c0","VarietyProfit":"2add303b","WeekProfit":"84e33993","YieldDist":"c7702ed4","chunk-594d6d48":"6660f05d","Equities~NetValue":"f549d8fc","Equities":"3134bc9a","NetValue":"a7786ea1","general":"5c6ca77e","home":"26dedeb5","DailySett":"06944b6c","HoldTotal":"54e39c7b","OptHoldTotal":"25a8c73c","OptTradeDetail":"e03a326f","Report":"b2f587cf","TakeDetail":"83e7b2b3","TakeTotal":"f567ade5","TradeDetail":"385d5851","account":"00faf8e7","analysis":"ceecb761","login":"44124efd","replay":"ffe0cc4f","chunk-07fc8797":"b2a2f485"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"CycleOdds":1,"CycleProfit":1,"Dispersion":1,"DynamicRetreat":1,"Exposure":1,"FeeRefund":1,"FundChange":1,"LongProfit":1,"LongShort":1,"MonthProfit":1,"Overnight":1,"ProfitCurve":1,"ReturnRatio":1,"Sharp":1,"ShortProfit":1,"SingleVariety~VarietyWeekProfit~varietyMonthProfit":1,"SingleVariety":1,"VarietyWeekProfit":1,"varietyMonthProfit":1,"TakeCycle":1,"TopTen":1,"TradeStruct":1,"VarietyOdds":1,"VarietyProfit":1,"WeekProfit":1,"YieldDist":1,"Equities~NetValue":1,"Equities":1,"NetValue":1,"general":1,"home":1,"DailySett":1,"HoldTotal":1,"OptHoldTotal":1,"OptTradeDetail":1,"Report":1,"TakeDetail":1,"TakeTotal":1,"TradeDetail":1,"account":1,"analysis":1,"login":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"CycleOdds~CycleProfit~Dispersion~DynamicRetreat~Equities~Exposure~FeeRefund~FundChange~LongProfit~Lo~7ae58261":"CycleOdds~CycleProfit~Dispersion~DynamicRetreat~Equities~Exposure~FeeRefund~FundChange~LongProfit~Lo~7ae58261","CycleOdds":"CycleOdds","CycleProfit":"CycleProfit","Dispersion":"Dispersion","DynamicRetreat":"DynamicRetreat","Exposure":"Exposure","FeeRefund":"FeeRefund","FundChange":"FundChange","LongProfit":"LongProfit","LongShort":"LongShort","MonthProfit":"MonthProfit","Overnight":"Overnight","ProfitCurve":"ProfitCurve","ReturnRatio":"ReturnRatio","Sharp":"Sharp","ShortProfit":"ShortProfit","SingleVariety~VarietyWeekProfit~varietyMonthProfit":"SingleVariety~VarietyWeekProfit~varietyMonthProfit","SingleVariety":"SingleVariety","VarietyWeekProfit":"VarietyWeekProfit","varietyMonthProfit":"varietyMonthProfit","TakeCycle":"TakeCycle","TopTen":"TopTen","TradeStruct":"TradeStruct","VarietyOdds":"VarietyOdds","VarietyProfit":"VarietyProfit","WeekProfit":"WeekProfit","YieldDist":"YieldDist","Equities~NetValue":"Equities~NetValue","Equities":"Equities","NetValue":"NetValue","general":"general","home":"home","DailySett":"DailySett","HoldTotal":"HoldTotal","OptHoldTotal":"OptHoldTotal","OptTradeDetail":"OptTradeDetail","Report":"Report","TakeDetail":"TakeDetail","TakeTotal":"TakeTotal","TradeDetail":"TradeDetail","account":"account","analysis":"analysis","login":"login","replay":"replay"}[chunkId]||chunkId) + "." + {"CycleOdds~CycleProfit~Dispersion~DynamicRetreat~Equities~Exposure~FeeRefund~FundChange~LongProfit~Lo~7ae58261":"31d6cfe0","CycleOdds":"c4c68750","CycleProfit":"a3f90fd0","Dispersion":"4f705ce5","DynamicRetreat":"51f6036a","Exposure":"9caf9a51","FeeRefund":"f00272b8","FundChange":"0fbe7f3b","LongProfit":"5f1e4474","LongShort":"d28a9b1f","MonthProfit":"7b3951d6","Overnight":"72120a5d","ProfitCurve":"0fbe7f3b","ReturnRatio":"0f77c62d","Sharp":"51f6036a","ShortProfit":"0ffd7e03","SingleVariety~VarietyWeekProfit~varietyMonthProfit":"b5bb4fe2","SingleVariety":"6eb53ca5","VarietyWeekProfit":"6eb53ca5","varietyMonthProfit":"6eb53ca5","TakeCycle":"76408381","TopTen":"7b3951d6","TradeStruct":"00087eb2","VarietyOdds":"df4f7de0","VarietyProfit":"7a92a734","WeekProfit":"285d62c9","YieldDist":"b6504cb2","chunk-594d6d48":"31d6cfe0","Equities~NetValue":"6ae4fae6","Equities":"0aab16af","NetValue":"0aab16af","general":"d221e5ba","home":"65d54e1f","DailySett":"fb1b47e1","HoldTotal":"a4c90924","OptHoldTotal":"a4c90924","OptTradeDetail":"a4c90924","Report":"9201237c","TakeDetail":"a4c90924","TakeTotal":"9a84e92f","TradeDetail":"a4c90924","account":"fcbe8834","analysis":"f86e3b6d","login":"cac26a6e","replay":"31d6cfe0","chunk-07fc8797":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
